import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() { 
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },





    //// ********************************| Vehicles |********************************


    GetVehicles(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Vehicles/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllVehicles() {
        return axios.get(`api/admin/Vehicles/GetAll`);
    },

    AddVehicles(bodyObject) {
        return axios.post(`api/admin/Vehicles/Add`, bodyObject);
    },

    EditVehicles(bodyObject) {
        return axios.post(`api/admin/Vehicles/Edit`, bodyObject);
    },

    DeleteVehicles(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/Delete`);
    },


    //// ********************************| End Vehicles |****************************




    //// ********************************| Invoice |********************************


    GetRequest(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Vehicles/Request/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AddRequest(bodyObject) {
        return axios.post(`api/admin/Vehicles/Request/Add`, bodyObject);
    },

    DeleteRequest(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/Request/Delete`);
    },

    AcceptRequest(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/Request/AcceptRequest`);
    },



    GetInvoices(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Vehicles/Invoices/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    Start(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/Invoices/Start`);
    },

    Ready(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/Invoices/Ready`);
    },

    Delivered(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/Invoices/Delivered`);
    },




    //InvoicesItems
    AddInvoicesItems(bodyObject) {
        return axios.post(`api/admin/Vehicles/InvoicesItems/Add`, bodyObject);
    },

    GetInvoicesItems(Id) {
        return axios.get(`api/admin/Vehicles/InvoicesItems/Get?Id=${Id}`);
    },

    DeleteInvoicesItems(Id) {
        return axios.post(`api/admin/Vehicles/${Id}/InvoicesItems/Delete`);
    },


    //// ********************************| End Vehicles |****************************


    


    //// ********************************| Products |********************************


    GetProducts(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Products/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllProducts() {
        return axios.get(`api/admin/Products/GetAll`);
    },

    AddProducts(bodyObject) {
        return axios.post(`api/admin/Products/Add`, bodyObject);
    },

    EditProducts(bodyObject) {
        return axios.post(`api/admin/Products/Edit`, bodyObject);
    },

    ChangeStatusProducts(Id) {
        return axios.post(`api/admin/Products/${Id}/ChangeStatus`);
    },

    DeleteProducts(Id) {
        return axios.post(`api/admin/Products/${Id}/Delete`);
    },



    //ProductsCounts

    GetAllProductsCounts() {
        return axios.get(`api/admin/Products/Counts/GetAll`);
    },

    GetProductsCounts(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Products/Counts/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    //// ********************************| End Of Products |********************************





    //// ********************************| Financial |********************************

    GetFinancial(pageNo, pageSize, Search, ByCustomersId, BySupplierId, ByPaymentsMethodsId, ByType) {
        return axios.get(`api/admin/Financial/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &CustomersId=${ByCustomersId}&SupplierId=${BySupplierId}&PaymentsMethodsId=${ByPaymentsMethodsId}&Type=${ByType}`);
    },



    GetInvoiceNumber(Type) {
        return axios.get(`api/admin/Financial/Invoice/GetInvoiceNumber?Type=${Type}`);
    },

    GetInvoiceIn(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/InvoiceIn/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },
   
    AddInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Add`, bodyObject);
    },

    EditInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Edit`, bodyObject);
    },

    SaveInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Save`, bodyObject);
    },

    ConfirmInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Confirm`);
    },

    CancelInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Cancel`);
    },

    DeleteInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Delete`);
    },



    //InvoiceOut
    AddInvoiceOut(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceOut/Add`, bodyObject);
    },

    SaveInvoiceOut(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceOut/Save`, bodyObject);
    },

    GetInvoiceOut(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/InvoiceOut/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },




    //Item
    GetInvoiceProducts(Id) {
        return axios.get(`api/admin/Financial/Invoice/Item/Get?Id=${Id}`);
    },

    AddItemToInvoice(bodyObject) {
        return axios.post(`api/admin/Financial/Invoice/Item/Add`, bodyObject);
    },

    DeleteInvoiceItem(Id) {
        return axios.post(`api/admin/Financial/${Id}/Invoice/Item/Delete`);
    },


    //Installments
    GetInvoiceInstallments(Id) {
        return axios.get(`api/admin/Financial/Invoice/Installments/Get?Id=${Id}`);
    },

    AddInstallment(bodyObject) {
        return axios.post(`api/admin/Financial/Invoice/Installments/Add`, bodyObject);
    },

    DeleteInstallment(Id) {
        return axios.post(`api/admin/Financial/${Id}/Invoice/Installments/Delete`);
    },



    //// ********************************| End Of Financial |********************************






    // ********************************| Start Dictionaries |******************************

    // Services
    GetServices(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Services/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllServices() {
        return axios.get(`api/admin/Dictionaries/Services/GetAll`);
    },

    AddServices(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Services/Add`, bodyObject);
    },

    EditServices(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Services/Edit`, bodyObject);
    },

    DeleteServices(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Services/Delete`);
    },

    ChangeStatusServices(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Services/ChangeStatus`);
    },


    // Items
    GetItems(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Items/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllItems() {
        return axios.get(`api/admin/Dictionaries/Items/GetAll`);
    },

    AddItems(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Items/Add`, bodyObject);
    },

    EditItems(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Items/Edit`, bodyObject);
    },

    DeleteItems(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Items/Delete`);
    },

    ChangeStatusItems(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Items/ChangeStatus`);
    },




    // Manufacturers
    GetManufacturers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Manufacturers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllManufacturers() {
        return axios.get(`api/admin/Dictionaries/Manufacturers/GetAll`);
    },

    AddManufacturers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Manufacturers/Add`, bodyObject);
    },

    EditManufacturers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Manufacturers/Edit`, bodyObject);
    },

    DeleteManufacturers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Manufacturers/Delete`);
    },

    ChangeStatusManufacturers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Manufacturers/ChangeStatus`);
    },




    // VehiclesModels
    GetVehiclesModels(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/VehiclesModels/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllVehiclesModels(Id) {
        return axios.get(`api/admin/Dictionaries/VehiclesModels/GetAll?Id=${Id}`);
    },

    AddVehiclesModels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/VehiclesModels/Add`, bodyObject);
    },

    EditVehiclesModels(bodyObject) {
        return axios.post(`api/admin/Dictionaries/VehiclesModels/Edit`, bodyObject);
    },

    DeleteVehiclesModels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/VehiclesModels/Delete`);
    },

    ChangeStatusVehiclesModels(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/VehiclesModels/ChangeStatus`);
    },


    //Suppliers
    GetSuppliers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Suppliers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSuppliers() {
        return axios.get(`api/admin/Dictionaries/Suppliers/GetAll`);
    },

    AddSuppliers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Suppliers/Add`, bodyObject);
    },

    EditSuppliers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Suppliers/Edit`, bodyObject);
    },

    DeleteSuppliers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Suppliers/Delete`);
    },

    ChangeStatusSuppliers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Suppliers/ChangeStatus`);
    },



    // Stocking
    GetStocking(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Stocking/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllStocking() {
        return axios.get(`api/admin/Dictionaries/Stocking/GetAll`);
    },

    AddStocking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Stocking/Add`, bodyObject);
    },

    EditStocking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Stocking/Edit`, bodyObject);
    },

    DeleteStocking(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Stocking/Delete`);
    },

    ChangeStatusStocking(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Stocking/ChangeStatus`);
    },



    // PaymentsMethods
    GetPaymentsMethods(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PaymentsMethods/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPaymentsMethods() {
        return axios.get(`api/admin/Dictionaries/PaymentsMethods/GetAll`);
    },

    AddPaymentsMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentsMethods/Add`, bodyObject);
    },

    EditPaymentsMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentsMethods/Edit`, bodyObject);
    },

    DeletePaymentsMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentsMethods/Delete`);
    },

    ChangeStatusPaymentsMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentsMethods/ChangeStatus`);
    },











    //Dashboard
    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************










    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetUserNotifications() {
        return axios.get(`api/admin/Users/GetNotifications`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    GetAllCustomers() {
        return axios.get(`api/admin/Users/GetAllCustomers`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },



    // ********************************| End Of Users |********************************



}